import React, { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { Form, Button, InputGroup, Row, Col, Container, Table, FloatingLabel, Card } from 'react-bootstrap'
import './mantenedor.css'
import ModalInformativo from '../../components/Modal'
import apiService from '../../services/api'

//constantes
const BASE_TITLE = process.env.REACT_APP_BASE_TITLE

export default function Mantenedor() {
    //CONSTANTES
    const { accounts } = useMsal();
    const { name } = accounts[0] ?? {}
    const emptyForm = {
        usuario: "",
        rol: "",
        segmento: "",
        sucursal: "",
        estado: null
    }

    //USESTATES
    const [users, setUsers] = useState([])
    const [inputState, setInputState] = useState(true)
    const [showNewForm, setShowNewForm] = useState(false)
    const [showSvBtn, setShowSvBtn] = useState(false)
    const [inputForm, setInputForm] = useState(emptyForm)
    const [textModal, setTextModal] = useState()
    const [showModal, setShowModal] = useState()



    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);


    const handleEditButton = () => {
        setInputState(false)
        setInputForm(emptyForm)
        setShowNewForm(false)
        setShowSvBtn(true)
    }

    const handleNewButton = () => {
        setShowNewForm(true)
    }


    const handleSaveButton = async () => {
        try {
            const response = await apiService.updateUserList(users);
            
            if (response.res) {
                setShowModal(true)
                setTextModal("Base de Accesos Actualizada")
                setInputState(true)
                setShowSvBtn(false)
            } else {
                setShowModal(true)
                setTextModal("Estimado Presentamos Problemas para realizar la Actualizacion")
            }
        } catch (error) {
            console.error("Error al actualizar usuarios:", error.message)
            setShowModal(true)
            setTextModal("Estimado Presentamos Problemas para realizar la Actualizacion")
        }
    }

    const handleSelectForm = (index, param, value) => {
        users[index][param] = value

    }

    const handleInputForm = (index, param, value) => {
        users[index][param] = value
    }

    const handleEstadpSwitchForm = (index, param, value) => {
        users[index][param] = value

    }

    const handleNewSvButton = async () => {
        if (
            inputForm.usuario === "" &&
            inputForm.rol === "" &&
            inputForm.segmento === "" &&
            inputForm.sucursal === "" &&
            inputForm.estado === 0
        ) {
            setShowNewForm(false)
        } else if (
            inputForm.usuario === "" ||
            inputForm.rol === "" ||
            inputForm.segmento === "" ||
            inputForm.sucursal === "" ||
            inputForm.estado === null
        ) {
            setShowModal(true)
            setTextModal("Favor ingrese todos los Datos solicitados")

        } else {

            if (!isEmail(inputForm.usuario)) {
                setShowModal(true)
                setTextModal("Favor de ingresar correo en formato correspondiente (ejemplo@sura.cl)")
            } else {
                try {
                    const response = await apiService.addUser(inputForm.usuario, inputForm);
                    
                    if (response.res) {
                        users.push(inputForm)
                        setInputForm(emptyForm)
                        setShowNewForm(false)
                        setShowModal(true)
                        setTextModal("Nuevo Usuario Ingresado")
                    } else {
                        setShowModal(true)
                        setTextModal("Estimado Presentamos Problemas para realizar el ingreso")
                    }
                } catch (error) {
                    console.error("Error al agregar usuario:", error.message)
                    setShowModal(true)
                    setTextModal("Estimado Presentamos Problemas para realizar el ingreso")
                }
            }

        }
    }

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await apiService.getUserList();
                
                if (response && Array.isArray(response.data)) {
                    setUsers(response.data)
                } else {
                    setShowModal(true)
                    setTextModal("Estimado presentamos problemas para obtener la lista de usuarios")
                    setUsers([])
                }
            } catch (error) {
                console.error("Error al obtener usuarios:", error.message)
                setShowModal(true)
                setTextModal("Estimado presentamos problemas para obtener la lista de usuarios")
                setUsers([])
            }
        }

        fetchUsers()
    }, [])

    return (
        <>
            <ModalInformativo
                onClose={() => setShowModal(false)}
                show={showModal}
                children={textModal}
            ></ModalInformativo>
            <h1 className='pt-5'>Mantenedor {BASE_TITLE}</h1>
            <p>Sesion: {name}</p>
            <Container className='pt-3'>
                <Row>
                    <Col lg={2} />
                    <Col lg={8}>
                        <Row className="mb-2">
                            <InputGroup >
                                <Button variant="success" onClick={() => handleNewButton()}>Añadir +</Button>
                                <Button variant="secondary" onClick={() => handleEditButton()}>Editar</Button>
                                {showSvBtn && <Button variant="primary" onClick={() => handleSaveButton()}>Guardar</Button>}

                            </InputGroup>
                        </Row>
                        <Row className="mb-2">
                            {showNewForm &&

                                <Card border="light" className="mb-3">
                                    <Card.Body>
                                        <InputGroup className="" >
                                            <FloatingLabel
                                                controlId="floatingTextarea"
                                                label="Correo @sura"
                                                className="mb-3"
                                            >
                                                <Form.Control as="Input" value={inputForm.usuario} onChange={e => inputForm.usuario = e.target.value.toLowerCase()} />
                                            </FloatingLabel>
                                            <FloatingLabel
                                                controlId="floatingTextarea"
                                                label="Sucursal"
                                                className="mb-3"
                                            >
                                                <Form.Select aria-label="Default select example" onChange={e => inputForm.sucursal = e.target.value}>
                                                    <option selected ></option>
                                                    <option value={"Casa Matriz"}>Casa Matriz</option>
                                                    <option value={"Apoquindo"}>Apoquindo</option>
                                                    <option value={"No informado"}>No informado</option>
                                                </Form.Select>
                                                {/* <Form.Control as="Input" value={inputForm.sucursal} onChange={e => inputForm.sucursal = e.target.value}></Form.Control> */}
                                            </FloatingLabel>
                                            <FloatingLabel
                                                controlId="floatingTextarea"
                                                label="Supervisor"
                                                className="mb-3"
                                            >
                                                <Form.Control as="Input" value={inputForm.segmento} onChange={e => inputForm.segmento = e.target.value}></Form.Control>
                                            </FloatingLabel>
                                            <FloatingLabel
                                                controlId="floatingTextarea"
                                                label="Rol"
                                            >
                                                <Form.Select aria-label="Default select example" onChange={e => inputForm.rol = e.target.value}>
                                                    <option selected ></option>
                                                    <option value="admin">admin</option>
                                                    <option value="agent">Ejecutivo</option>
                                                </Form.Select>
                                            </FloatingLabel>
                                            <FloatingLabel
                                                controlId="floatingTextarea"
                                                label="Acceso"
                                            >
                                                <Form.Select aria-label="Default select example" onChange={e => inputForm.estado = parseInt(e.target.value)}>
                                                    <option selected ></option>
                                                    <option value={1}>Activo</option>
                                                    <option value={0}>Desactivado</option>
                                                </Form.Select>
                                            </FloatingLabel>
                                        </InputGroup>
                                    </Card.Body>
                                    <Card.Footer >
                                        <InputGroup  >
                                            <Button size="sm" variant="primary" onClick={() => handleNewSvButton()}>Guardar Nuevo</Button>
                                            <Button size="sm" variant="danger" onClick={() => { setInputForm(emptyForm); setShowNewForm(false) }}>Cerrar</Button>
                                        </InputGroup>
                                    </Card.Footer>
                                </Card>

                            }
                        </Row>
                        <Row className="mb-5">
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Correo @Sura</th>
                                        <th>Sucursal</th>
                                        <th>Supervisor</th>
                                        <th>Rol</th>
                                        <th>Acceso</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {users && users.map((user, i) => {
                                        return <tr>
                                            <td>
                                                {i + 1}
                                            </td>
                                            <td>
                                                <Form.Control
                                                    as="Input"
                                                    value={user.usuario}
                                                    placeholder="XXXXXX@sura.cl"
                                                    aria-label="Disabled input example"
                                                    disabled={true}
                                                    onChange={(event) => handleInputForm(i, "usuario", event.target.value.toLowerCase())}
                                                />
                                            </td>
                                            <td>
                                                <Form.Select aria-label="Default select example" disabled={inputState} onChange={(event) => handleInputForm(i, "sucursal", event.target.value)}>
                                                    <option selected={user.sucursal === "Casa Matriz" ? true : false} value={"Casa Matriz"}>Casa Matriz</option>
                                                    <option selected={user.sucursal === "Apoquindo" ? true : false} value={"Apoquindo"}>Apoquindo</option>
                                                    <option selected={user.sucursal === "No informado" ? true : false} value={"No informado"}>No informado</option>
                                                </Form.Select>
                                            </td>
                                            <td>
                                                <Form.Control
                                                    as="Input"
                                                    value={user.segmento}
                                                    placeholder="Supervisor"
                                                    aria-label="Disabled input example"
                                                    disabled={inputState}
                                                    onChange={(event) => handleInputForm(i, "segmento", event.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <Form.Select aria-label="Default select example" disabled={inputState} onChange={(event) => handleSelectForm(i, "rol", event.target.value)}>
                                                    <option selected={user.rol === "admin" ? true : false} value="admin">admin</option>
                                                    <option selected={user.rol === "agent" ? true : false} value="agent">Ejecutivo</option>
                                                </Form.Select>
                                            </td>
                                            <td>
                                                <Form.Check
                                                    id={`switch-${i}`}
                                                    type="switch"
                                                    disabled={inputState}
                                                    defaultChecked={user.estado === 1 ? true : false}
                                                    onChange={(event) => handleEstadpSwitchForm(i, "estado", event.target.checked ? 1 : 0)}
                                                />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>
                        </Row>
                    </Col>
                    <Col lg={2} />
                </Row>

            </Container>
        </>
    );
}